define(function () {
    return function (app) {
        app.directive('tabs', ['$timeout', '$window', function ($timeout, $window) {
            return {
                restrict: "A",
                bindToController: {
                    tabs: "&",
                    triggers: "&",
                    readmore: "&",
                    maxheight: "=",
                },
                controllerAs: 'ctrl',
                controller: ['$scope', '$element', '$attrs', '$timeout', '$window' ,function ($scope, $element, $attrs, $timeout, $window) {
                    $scope.tabs = [];
                    $scope.triggers = [];
                    $scope.readmore = false;
                    $scope.toggleLabel = '';
                    $scope.initialheight = '';
                    $scope.hasMore = false;
                    var readMoreLabel = $attrs.readmorelbl;

                    $scope.activate = function (which) {
                        angular.forEach(this.tabs, function (item, key) {
                            item.active = (item.id === which);
                            $scope.triggers[item.id].active = item.active;
                            if (item.active) {
                                $timeout(function () {
                                    $($element).animate({ 'height': getCurrentDesktopHeight() }, 500);
                                })
                                if ($scope.readmore) {
                                    $scope.readmore = false;
                                    $scope.toggleLabel = readMoreLabel;
                                }
                                if (item.numOfHyperlinks != null) {
                                    $scope.hasMore = item.numOfHyperlinks >= 13;
                                }
                            }
                        });
                    };

                    $scope.addTab = function () {
                        var id = $scope.tabs.length;
                        $scope.tabs[id] = {
                            id: id,
                            active: (id === 0)
                        };
                        return $scope.tabs[id];
                    };

                    $scope.addTabWithParams = function (numOfHyperlinks) {
                        var id = $scope.tabs.length;
                        $scope.tabs[id] = {
                            id: id,
                            active: (id === 0),
                            numOfHyperlinks: numOfHyperlinks
                        };
                        return $scope.tabs[id];
                    };

                    $scope.addTrigger = function (t) {
                        var id = $scope.triggers.length;
                        $scope.triggers[id] = {
                            tabid: id,
                            active: (id === 0)
                        };
                        return $scope.triggers[id];
                    };

                    $scope.init = function () {
                        //initialize first tab
                        $timeout(function () {
                            if ($scope.tabs.length > 0) {
                                $scope.activate(0);
                            }
                        }, 250);
                    };

                    function getCurrentDesktopHeight() {
                        const barHeight = $('.readmore-trigger').outerHeight();
                        const tenLeftTabsHeight = 475;
                        const fullLeftVerticalTabsHeight = $($element)
                            .find('.verticaltabs-column-left')
                            .find('.verticaltabs-column-content')
                            .outerHeight();

                        const fullRightVerticalTabsHeight = $($element)
                            .find('.verticaltabs-column-right')
                            .find('.verticaltabscontent')
                            .find('.active')
                            .find('.linklist-list')
                            .children();

                        // calculate the height of the first 14 items
                        let rightListItemsHeight = 44;
                        let additionalHeight = 0;

                        for (let i = 0; i < 13; i++) {
                            if (!(fullRightVerticalTabsHeight[i] == null)) {
                                let itemHeight = $(fullRightVerticalTabsHeight[i]).find('.arrow-link').outerHeight(true);
                                if (itemHeight % 33 !== 0) {
                                    additionalHeight += 9;
                                }
                                rightListItemsHeight += itemHeight;
                            }
                            if (rightListItemsHeight > fullLeftVerticalTabsHeight && rightListItemsHeight > tenLeftTabsHeight) {
                                return rightListItemsHeight + barHeight;
                            }
                        }
                        return (fullLeftVerticalTabsHeight > tenLeftTabsHeight ? fullLeftVerticalTabsHeight : tenLeftTabsHeight) + barHeight;
                    }
                }],

                link: function ($scope, $element, $attrs) {
                    $timeout(function () {
                        const barHeight = $('.readmore-trigger').outerHeight();
                        if ($window.innerWidth < 750) {
                            $scope.initialheight = (getInitialMobileHeight() + barHeight).toString() + "px";
                            $scope.maxheight = (getMaxMobileHeight()).toString() + "px";
                            $($element).css("max-height", $scope.initialheight.toString() + "px");
                        } else {
                            $scope.initialheight = (getCurrentDesktopHeight() + barHeight).toString() + "px";
                            $scope.maxheight = (getMaxDesktopHeight()).toString() + "px";
                            $($element).height($scope.initialheight);
                        }
                    });
                    var readMoreLabel = $attrs.readmorelbl;
                    var readLessLabel = $attrs.readlesslbl;
                    $scope.toggleLabel = readMoreLabel;

                    $scope.readMore = function (event) {
                        if (event) {
                            event.preventDefault();
                        }

                        if ($scope.readmore) {
                            $scope.readmore = false;
                            $($element).animate({ 'height': getCurrentDesktopHeight() }, 500);
                            $scope.toggleLabel = readMoreLabel;
                        } else {
                            $scope.readmore = true;

                            $($element).animate({ 'height': getCurrentMaxDesktopHeight(event) }, 500);

                            $scope.toggleLabel = readLessLabel;
                        }
                    };


                    function getCurrentDesktopHeight() {
                        const barHeight = $('.readmore-trigger').outerHeight();
                        const tenLeftTabsHeight = 475;
                        const fullLeftVerticalTabsHeight = $($element)
                            .find('.verticaltabs-column-left')
                            .find('.verticaltabs-column-content')
                            .outerHeight();

                        const fullRightVerticalTabsHeight = $($element)
                            .find('.verticaltabs-column-right')
                            .find('.verticaltabscontent')
                            .find('.active')
                            .find('.linklist-list')
                            .children();

                        // calculate the height of the first 14 items
                        let rightListItemsHeight = 44;
                        let additionalHeight = 0;

                        for (let i = 0; i < 13; i++) {
                            if (!(fullRightVerticalTabsHeight[i] == null)) {
                                let itemHeight = $(fullRightVerticalTabsHeight[i]).find('.arrow-link').outerHeight(true);
                                if (itemHeight % 33 !== 0) {
                                    additionalHeight += 9;
                                }
                                rightListItemsHeight += itemHeight;
                            }
                            if (rightListItemsHeight > fullLeftVerticalTabsHeight && rightListItemsHeight > tenLeftTabsHeight) {
                                return rightListItemsHeight + barHeight;
                            }
                        }
                        return (fullLeftVerticalTabsHeight > tenLeftTabsHeight ? fullLeftVerticalTabsHeight : tenLeftTabsHeight) + barHeight;
                    }

                    function getMaxDesktopHeight() {
                        return $($element)
                            .find('.verticaltabs-column-right')
                            .find('.verticaltabscontent')
                            .outerHeight();
                    }

                    function getCurrentMaxDesktopHeight(event) {
                        return $(event.currentTarget)
                            .siblings('.verticaltabs-column-right')
                            .find('.verticaltabscontent')
                            .outerHeight();
                    }


                    function getInitialMobileHeight() {
                        const fullLeftVerticalTabsHeight = $($element)
                            .find('.verticaltabs-column-left')
                            .find('.verticaltabs-column-content')
                            .outerHeight();
                        const fullRightVerticalTabsHeight = $($element)
                            .find('.verticaltabs-column-right')
                            .find('.verticaltabscontent')
                            .find('.active')
                            .find('.linklist-block')
                            .outerHeight();

                        return fullLeftVerticalTabsHeight + fullRightVerticalTabsHeight;
                    }

                    function getMaxMobileHeight() {
                        const fullLeftVerticalTabsHeight = $($element)
                            .find('.verticaltabs-column-left')
                            .find('.verticaltabs-column-content')
                            .outerHeight();
                        const fullRightVerticalTabsHeight = $element
                            .find('.verticaltabs-column-right')
                            .find('.verticaltabscontent')
                            .outerHeight();
                        return fullLeftVerticalTabsHeight + fullRightVerticalTabsHeight;
                    }
                }
            }
        }]);

        //inherits from tabs directive
        app.directive('tabsResponder', [function () {
            return {
                restrict: "A",
                require: "^tabs",
                scope: true,
                controllerAs: 'ctrl',
                controller: ['$scope', '$attrs', function ($scope, $attrs) {
                    if ($attrs.numofhyperlinks != null) {
                        $scope.tab = $scope.addTabWithParams(parseInt($attrs.numofhyperlinks));
                    } else {
                        $scope.tab = $scope.addTab();
                    }
                }]
            }
        }]);

        //inherits from tabs directive
        app.directive('tabsTrigger', [function () {
            return {
                restrict: "A",
                require: "^tabs",
                scope: true,
                bindToController: {},
                controllerAs: 'ctrl',
                controller: ['$scope', function ($scope) {
                    $scope.trigger = $scope.addTrigger();
                    $scope.activateTab = function (event) {
                        if (event) event.preventDefault();
                        $scope.activate($scope.trigger.tabid);
                    }
                }]
            }
        }]);
    }
});